
export function isValidIdentifier(identifier) {
    return typeof identifier === "string" && identifier.length === 24;
}
